import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';

export const LugaresRecuentoField = ({ lugares, value, onChange }) => {
  const toggle = (codigo, checked) => onChange(checked ? [...value, codigo] : value.filter((c) => c !== codigo));
  return (
    <div className="col-span-2 rounded-lg border border-orange-100 bg-orange-50/40 p-3" data-testid="user-lugares-recuento-field">
      <Label>Lugares de recuento (Justo)</Label>
      <div className="grid grid-cols-2 gap-2 mt-2">
        {lugares.map((l) => (
          <label key={l.codigo} className="flex items-center gap-2 text-sm text-slate-700">
            <Checkbox
              checked={value.includes(l.codigo)}
              onCheckedChange={(c) => toggle(l.codigo, !!c)}
              data-testid={`user-lugar-${l.codigo}`}
            />
            {l.local} - {l.nombre_bodega_justo}
          </label>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-2">El usuario podrá hacer el recuento semanal de estos lugares. No cambia su local ni bodega asignada.</p>
    </div>
  );
};
